/** @format */

class ZzeungError extends Error {
  constructor(res) {
    super(res.retMessage);
    this.name = this.constructor.name;
    this.retCode = res.retCode;
  }
}

class Zzeung {
  static _callHandler(handlerName, param) {
    if (window.myIdBridge) {
      if (window.myIdBridge.callHandler) {
        return window.myIdBridge.callHandler(handlerName, param);
      } else {
        const _callHandlerID = setTimeout(() => {});
        window.myIdBridge._callHandler(
          handlerName,
          _callHandlerID,
          JSON.stringify([param])
        );
        return new Promise((resolve) => {
          window.myIdBridge[_callHandlerID] = (res) => {
            clearTimeout(_callHandlerID);
            resolve(res);
          };
        });
      }
    }
    if (window.flutter_inappwebview) {
      if (window.flutter_inappwebview.callHandler) {
        return window.flutter_inappwebview.callHandler(handlerName, param);
      } else {
        const _callHandlerID = setTimeout(() => {});
        window.flutter_inappwebview._callHandler(
          handlerName,
          _callHandlerID,
          JSON.stringify([param])
        );
        return new Promise((resolve) => {
          window.flutter_inappwebview[_callHandlerID] = (res) => {
            clearTimeout(_callHandlerID);
            resolve(res);
          };
        });
      }
    }
  }

  static request(params, cb = null) {
    try {
      return Zzeung._callHandler("request", params).then((payload) => {
        const response = JSON.parse(payload);
        if (response.retCode === 0) {
          if (!!cb) {
            cb(response);
          }
          return Promise.resolve(response);
        }
        throw new ZzeungError(response);
      });
    } catch (e) {
      throw e;
    }
  }

  static sendVcp(params, cb = null) {
    try {
      return Zzeung._callHandler("request", params).then((payload) => {
        const response = JSON.parse(payload);
        if (response.retCode === 0) {
          if (!!cb) {
            cb(response);
          }
          return Promise.resolve(response);
        }
        throw new ZzeungError(response);
      });
    } catch (e) {
      throw e;
    }
  }

  static close(msg = null) {
    try {
      return Zzeung._callHandler("close", msg);
    } catch (e) {
      throw e;
    }
  }

  static openWithBrowser(url = null) {
    try {
      return Zzeung._callHandler("Launch", url);
    } catch (e) {
      throw e;
    }
  }

  static hasValidCredential(param = null, cb = null) {
    /* 
      param: {
        did: string;
        vcType: string;
      }
    */
    try {
      if (!param) {
        return;
      }
      return Zzeung._callHandler("hasValidCredential", param).then(
        (payload) => {
          const response = JSON.parse(payload);
          if (!!cb) {
            return cb(response);
          }
          return Promise.resolve(response);
        }
      );
    } catch (e) {
      throw e;
    }
  }
  static OpenWebView(link = null) {
    try {
      Zzeung._callHandler("OpenWebView", link);
    } catch (e) {
      throw e;
    }
  }
  static CloseWebView() {
    try {
      Zzeung._callHandler("CloseWebView", null);
    } catch (e) {
      throw e;
    }
  }
}

export default Zzeung;
